import { isEmpty } from 'lodash'
import PostType from 'enums/PostType'
import Domain from 'enums/Domain'
import { StreamData } from 'types/streamData'
import { isRightToLeftText, setMarkers } from 'utils/rtlTextUtil'
import { getTwitterComplianceText } from 'utils/twitterComplianceUtil'
import { replaceEmojiWithTwEmoji } from 'utils/emojiUtil'
import { Metadata } from '../../adaptor/metadata'
import postTypeResolver from '../document/postTypeResolver'
import domainResolver from '../document/domainResolver'

const resolveParentTextRelatedFields = (metadata: Metadata) => {
  let parentText = ''
  let parentReplyToAuthors: string[] = []
  let isParentTextRtl
  let parentDistilledTexts

  const { postType } = postTypeResolver(metadata)
  const { domain } = domainResolver(metadata)
  if (
    (postType === PostType.TW_QUOTE || postType === PostType.TW_ORIGINAL) &&
    domain === Domain.TWITTER &&
    !isEmpty(metadata.getParentDistilledTexts())
  ) {
    parentText = metadata.getParentDistilledTexts()!.join(' ')

    const parentDisplayTextRange = metadata.getParentDisplayTextRange()
    if (parentDisplayTextRange && parentDisplayTextRange.startOffset! > 0) {
      parentReplyToAuthors = parentText
        .substring(0, parentDisplayTextRange.startOffset! - 1)
        .split(' ')
      parentText = parentText.substring(parentDisplayTextRange.startOffset!)
    }

    isParentTextRtl = isRightToLeftText(parentText)
    parentText = setMarkers(parentText)!
    parentDistilledTexts = parentText
    parentText = getTwitterComplianceText(parentText, metadata.getParentMentionedUrls()!)
  }

  if (parentText) {
    parentText = replaceEmojiWithTwEmoji(parentText)
  }

  return {
    parentText,
    parentReplyToAuthors,
    isParentTextRtl,
    parentDistilledTexts
  } as StreamData
}

export default resolveParentTextRelatedFields
